<template>
  <div>
    <iframe width="100%" height="650px"
      src="https://lookerstudio.google.com/embed/u/0/reporting/c6e69c41-ebe8-4f69-9f71-856a067890cc/page/p_jk78nd1gud"
      frameborder="0" style="border:0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
}
</script>
